import React, { useEffect, useState } from "react";
import Table from "../../extra/Table";
import Pagination from "../../extra/Pagination";
import { connect, useDispatch, useSelector } from "react-redux";
import AttributeDialog from "./AttributeDialog";
import { warning } from "../../../util/Alert";
import dayjs from "dayjs";
import Button from "../../extra/Button";
import Iconb from "../../extra/Iconb";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { usePermission } from "../../../hooks/usePermission";
import {
  getAttribute,
  deleteAttribute,
  getAllSubcategory,
} from "../../store/attribute/attribute.action";
import EditInfo from "../../../assets/images/Edit.png";
import Delete from "../../../assets/images/Delete.svg"
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import Select from 'react-select';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { colors } from "../../../util/SkeletonColor";
import { baseURL } from "../../../util/config";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#ffccde' : 'white',
    color: state.isSelected ? 'white' : 'black',
    background: state.isSelected ? '#b93160' : undefined,
    cursor: 'pointer',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

const Attribute = (props) => {

  const { can } = usePermission();
  const canCreate = can("Attribute", "Create");
  const canEdit = can("Attribute", "Edit");
  const canDelete = can("Attribute", "Delete");

  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedOptions, setSelectedOptions] = useState("All");
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  const fieldTypeOptions = [
    { value: "All", label: "All" },
    { value: "5", label: "Dropdown" },
    { value: "6", label: "Checkboxes" },
  ];
  const [fieldType, setFieldType] = useState("All");

  const [selectedFieldType, setSelectedFieldType] = useState(fieldTypeOptions[0]);


  const { attribute } = useSelector((state) => state.attribute);

  const { dialogue, dialogueType, dialogueData } = useSelector(
    (state) => state.dialogue
  );
  const { subcategory } = useSelector((state) => state.attribute);


  useEffect(() => {
    dispatch(getAttribute({
      subCategoryId: selectedOptions.value || "All",
      fieldType: fieldType.value || "All"
    }));
  }, [dispatch, selectedOptions, fieldType]);

  useEffect(() => {
    setData(attribute);
  }, [attribute]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  // Delete PromoCode
  const handleDelete = (id) => {


    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          dispatch(deleteAttribute(id));
        }
      })
      .catch((err) => console.log(err));
  };


  const options = [
    { value: "All", label: "All" },
    ...subcategory.map((item) => ({
      value: item._id,
      label: item.name
    }))
  ];




  const handleChange = (selected) => {
    setSelectedOptions(selected);

    if (selected?.value === "All") {
      setData(attribute);
    } else {
      // specific subcategory filter kar ke dikhao
      const filtered = attribute.filter((attr) =>
        attr?.subcategories?.includes(selected.value)
      );
      setData(filtered);
    }
  };


  useEffect(() => {
    dispatch(getAllSubcategory());
  }, [])

  const handleFieldTypeChange = (e) => {
    const value = e.target.value;
    setFieldType(value);

    if (value === "All") {
      setData(attribute);
    } else {
      const filtered = attribute.filter((attr) => attr?.fieldType === value);
      setData(filtered);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Adjust the delay time as needed

    return () => clearTimeout(timer);
  }, []);



  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => <span className="text-white">{page * rowsPerPage + parseInt(index) + 1}</span>,
    },

    {
      Header: "Image",
      body: "image",
      Cell: ({ row }) => (
        <>
          {loading ? (
            <>
              <Skeleton
                height={40}
                width={40}
                style={{ borderRadius: "50px", cursor: "pointer" }}
                className="StripeElement "
                baseColor={colors?.baseColor}
                highlightColor={colors?.highlightColor}
              />
            </>
          ) : (
            <>
              <img
                src={row.attributes ? row.attributes[0]?.image.includes("http") ? row.attributes[0]?.image : baseURL + row.attributes[0]?.image : "/dummy.png"}
                style={{ borderRadius: "50px", cursor: "pointer", objectFit: "cover" }}
                height={45}
                width={45}
                alt="category"
                // onClick={() =>
                //   navigate("/admin/category/subCategory", {
                //     state: { id: row?._id },
                //   })
                // }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/defaultImage.png";
                }}
              />

            </>
          )}
        </>
      ),
    },

    {
      Header: "Name",
      body: "subcategory",
      Cell: ({ row }) => {
        // Check if row?.attributes exists and has at least one element
        const attribute = row?.attributes && row?.attributes.length > 0 ? row.attributes[0] : null;
        return <span className="fw-normal fs-6 text-white">{attribute ? attribute.name : "-"}</span>;
      },
    },

    {
      Header: "Subcategory",
      body: "name",
      Cell: ({ row }) => <span className="fw-normal fs-6 text-white">{row?.subCategory?.name ? row?.subCategory?.name : "-"}</span>,
    },

    {
      Header: "Type",
      body: "type",
      Cell: ({ row }) => {
        const typeMap = {
          1: "Text Input",
          2: "Number Input",
          3: "File Input",
          4: "Radio",
          5: "Dropdown",
          6: "Checkboxes",
        };

        const fieldType = row?.attributes?.[0]?.fieldType;
        return <span className="fw-normal fs-6 text-white">{typeMap[fieldType] || "Unknown"}</span>;
      },
    },



    {
      Header: "Created Date",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white fw-normal">{dayjs(row?.createdAt).format("DD MMM YYYY")}</span>
      ),
    },

    ...(canEdit ? [
      {
        Header: "Edit",
        body: "",
        Cell: ({ row }) => (
          <>
            <Iconb
              type="button"
              newClass={`themeFont boxCenter infobtn userBtn   `}
              btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
              style={{
                borderRadius: "50px",
                margin: "auto",
                height: "40px",
                width: "40px",
                color: "#160d98",
                padding: "0px"

              }}
              isImage={true}

              onClick={() =>
                dispatch({
                  type: OPEN_DIALOGUE,
                  payload: { data: row, type: "attribute" },
                })
              }

            />
          </>
        ),
      }
    ] : []),

    ...(canDelete ? [
      {
        Header: "Delete",
        body: "",
        Cell: ({ row }) => (
          <>
            <Iconb
              newClass={`themeFont boxCenter killbtn userBtn `}
              btnIcon={<DeleteIcon sx={{ color: '#FF4C51' }} />}
              style={{
                borderRadius: "50px",
                margin: "auto",
                height: "40px",
                width: "40px",
                color: "#160d98",
                padding: "0px"

              }}
              isImage={true}
              isDeleted={true}
              onClick={() => handleDelete(row?._id)}

            />
          </>
        ),
      }
    ] : []),

  ];

  return (
    <>
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Attribute</div>
          <div className="sellerMain">

            <div className="col-12" style={{ marginLeft: "28px" }}>
              {canCreate && (
                <Button
                  newClass={`whiteFont`}
                  btnColor={`btnBlackPrime `}
                  btnIcon={`fa-solid fa-plus `}
                  btnName={`Add`}
                  onClick={() => {
                    dispatch({
                      type: OPEN_DIALOGUE,
                      payload: { type: "attribute" },
                    });
                  }}
                  style={{ borderRadius: "5px", padding: "8px 32px", background: "#b93160" }}
                />
              )}
              {dialogue && dialogueType === "attribute" && (
                <AttributeDialog />
              )}
            </div>

            <div className="tableMain mt-2">
              <div className="d-flex justify-content-between">

                <div className="col-3" style={{ margin: "20px", zIndex: 50 }}>
                  <label>Subcategory</label>
                  <Select
                    // isMulti
                    options={options}
                    value={selectedOptions}
                    onChange={handleChange}
                    styles={customStyles}
                    placeholder="Select Subcategory..."
                  />
                </div>
                {/* 
                <div className="col-3" style={{ margin: "20px", zIndex: 50 }}>
                  <label>
                    Field Type
                  </label>
                  <select
                    className="form-control"
                    value={fieldType}
                    onChange={handleFieldTypeChange}
                    style={{ backgroundColor: "transparent", color: "#333333" }}
                  >
                    <option value="All">All</option>
                    <option value="1">Text Input</option>
                    <option value="2">Number Input</option>
                    <option value="3">File Input</option>
                    <option value="4">Radio</option>
                    <option value="5">Dropdown</option>
                    <option value="6">Checkboxes</option>
                  </select>
                </div> */}

                <div className="col-3" style={{ margin: "20px", zIndex: 50 }}>
                  <label>Field Type</label>
                  <Select
                    options={fieldTypeOptions}
                    value={fieldType}
                    onChange={(selected) => setFieldType(selected)}
                    styles={customStyles}
                    placeholder="Select field type..."
                  />
                </div>

              </div>
              <Table
                data={data}
                mapData={mapData}
                PerPage={rowsPerPage}
                Page={page}
                type={"client"}
              />
              <Pagination   //Pagination if need
                component="div"
                count={attribute?.length}
                serverPage={page}
                type={"client"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={attribute?.length}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getAttribute, deleteAttribute })(Attribute);
